// extracted by mini-css-extract-plugin
export default {"root":"animatedReveal_root__KYCtQ"};